// ---------------------------------------------------------------------------
// Shared types & initial-state factory for the teamFocusSession slice.
// ---------------------------------------------------------------------------

export interface Task {
    id: string;
    title: string;
    description?: string;
    status: "todo" | "inprogress" | "done";
    completed?: boolean;
    createdAt: string; // ISO string (serializable)
    updatedAt?: string;
    created_by: { id: string; name: string } | string;
    assigned_to?: { id: string; name: string } | string | null;
    assignedTo?: { id: string; name: string; avatar: string } | null;
    is_public: boolean;
    roomId?: string;
    text?: string;
}

export interface Note {
    id: string;
    note: string;
    createdAt: string; // ISO string
    is_public: boolean;
    created_by: string;
}

export interface Reminder {
    id: string;
    text: string;
    time: string;
    completed: boolean;
}

export interface TeamCheckin {
    id: string;
    title: string;
    checkinTime: string;
    created_by: string;
    is_public: boolean;
    roomId: string;
}

export interface TeamMember {
    id: string;
    name: string;
    avatar: string;
    isOnline: boolean;
    isMuted: boolean;
}

export interface TeamSessionState {
    // Goal & settings
    goal: string;
    duration: number; // minutes

    currentRoom: any | null;
    isHost: boolean;

    // Timer state
    sessionTimeLeft: number; // seconds
    sessionStarted: boolean;
    sessionPaused: boolean;
    sessionCompleted: boolean;

    // Tools state
    tasks: Task[];
    notes: Note[];
    reminders: Reminder[];
    checkins: TeamCheckin[];
    teamMembers: TeamMember[];

    // Loading / auxiliary flags
    notesLoading: boolean;
    checkinsLoading: boolean;
    tasksLoading: boolean;
    tasksError: string | null;

    // RTC token
    rtcToken: string | null;
    rtcTokenLoading: boolean;
    rtcTokenError: string | null;

    // Settings
    breakRemindersEnabled: boolean;
}

export interface TeamSessionsRootState {
    sessions: Record<string, TeamSessionState>;
}

export const createInitialTeamSessionState = (): TeamSessionState => ({
    goal: "Focus Session",
    duration: 25,
    currentRoom: null,
    isHost: false,
    sessionTimeLeft: 25 * 60,
    sessionStarted: false,
    sessionPaused: false,
    sessionCompleted: false,
    tasks: [],
    notes: [],
    reminders: [],
    checkins: [],
    teamMembers: [],
    notesLoading: false,
    checkinsLoading: false,
    tasksLoading: false,
    tasksError: null,
    rtcToken: null,
    rtcTokenLoading: false,
    rtcTokenError: null,
    breakRemindersEnabled: true,
});
